/**
 * Discount Code Activator
 *
 * Automatische Rabattcode-Aktivierung mit Client-Side Price Updates
 * - Product Page: sale-price + compare-at-price Update
 * - Cart Drawer: Line-Item Preise Update
 * - Anti-Flicker via localStorage
 * - WCAG 2.1 AA konform
 */

(function() {
  'use strict';

  /* ══════════════════════════════════════════════════
   * MULTI-INSTANCE SUPPORT
   * ══════════════════════════════════════════════════ */
  document.querySelectorAll('.discount-code-activator').forEach(function(activator) {
    initDiscountActivator(activator);
  });

  function initDiscountActivator(activator) {
    /* ══════════════════════════════════════════════════
     * CONFIG & DOM CACHE
     * ══════════════════════════════════════════════════ */
    var DISCOUNT_CODE = (activator.dataset.discountCode || '').toUpperCase().trim();
    if (!DISCOUNT_CODE) return;

    var ORIGINAL_CODE  = activator.dataset.discountCode.trim();
    var STORAGE_KEY    = activator.dataset.storageKey || 'discount_active';
    var BADGE_TEMPLATE = activator.dataset.badgeMessage || 'Rabattcode [code] ist aktiviert!';
    var MONEY_FORMAT   = activator.dataset.moneyFormat || '{{amount_with_comma_separator}} \u20ac';
    var CHECK_INTERVAL = 3000;
    var DEBUG          = false;
    var ROOT_URL       = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    var dom = {
      inactive : activator.querySelector('[data-state="inactive"]'),
      active   : activator.querySelector('[data-state="active"]'),
      loading  : activator.querySelector('[data-state="loading"]'),
      error    : activator.querySelector('[data-state="error"]'),
      badgeText: activator.querySelector('[data-badge-text]'),
      applyBtn : activator.querySelector('[data-discount-apply-btn]')
    };

    var priceState = {
      originalSaleHTML: null, originalSaleClass: null,
      originalCompareHTML: null, originalCompareHidden: true,
      originalPriceCents: null,
      updated: false, updating: false
    };

    var pollingInterval = null;
    var lastCartForDrawer = null;
    var initialCheckDone = false;

    /* ══════════════════════════════════════════════════
     * UTILITIES
     * ══════════════════════════════════════════════════ */
    function log() {
      if (DEBUG) console.log.apply(console, ['[DiscountActivator]'].concat([].slice.call(arguments)));
    }

    function storageSafe(action, key, value) {
      try {
        if (action === 'set') localStorage.setItem(key, value);
        else if (action === 'remove') localStorage.removeItem(key);
        else return localStorage.getItem(key);
      } catch(e) { return null; }
    }

    function fetchJSON(url, options) {
      var defaults = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
      var merged = Object.assign({}, defaults, options || {});
      if (merged.body && typeof merged.body === 'object' && !(merged.body instanceof FormData)) {
        merged.headers['Content-Type'] = 'application/json';
        merged.body = JSON.stringify(merged.body);
      }
      return fetch(url, merged).then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    }

    function fetchCartJSON(sections) {
      var url = ROOT_URL + 'cart.js';
      if (sections && sections.length) url += '?sections=' + sections.join(',');
      return fetchJSON(url);
    }

    /* ══════════════════════════════════════════════════
     * MONEY FORMATTING
     * ══════════════════════════════════════════════════ */
    function fmtMoney(cents) {
      if (typeof window.formatMoney === 'function') {
        try { return window.formatMoney(cents, MONEY_FORMAT); } catch(e) {}
      }
      if (typeof cents !== 'number' || isNaN(cents)) return '0,00 €';
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      var intPart = parts[0], decPart = parts[1];
      var replacements = {
        'amount_with_comma_separator'             : amount.replace('.', ','),
        'amount_no_decimals_with_comma_separator' : Math.round(cents / 100).toString(),
        'amount_with_period_and_comma_separator'  : intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + decPart,
        'amount_with_apostrophe_separator'        : intPart.replace(/\B(?=(\d{3})+(?!\d))/g, "'") + ',' + decPart,
        'amount_no_decimals'                      : Math.round(cents / 100).toString(),
        'amount'                                  : amount
      };
      var formatted = MONEY_FORMAT;
      Object.keys(replacements).sort(function(a, b) { return b.length - a.length; }).forEach(function(key) {
        formatted = formatted.replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g'), replacements[key]);
      });
      if (formatted.indexOf('{' + '{') !== -1) return amount.replace('.', ',') + ' \u20ac';
      return formatted;
    }

    function parsePriceToCents(priceText) {
      var cleaned = priceText.replace(/[^\d,\.]/g, '').trim();
      if (!cleaned) return null;
      var lastComma = cleaned.lastIndexOf(',');
      var lastDot = cleaned.lastIndexOf('.');
      if (lastComma > -1 && lastDot > -1) {
        /* Beide Trenner vorhanden: der spätere ist der Dezimaltrenner */
        if (lastComma > lastDot) {
          cleaned = cleaned.replace(/\./g, '').replace(/,/g, '.');
        } else {
          cleaned = cleaned.replace(/,/g, '');
        }
      } else if (lastComma > -1) {
        /* Nur Komma: 2 Nachkommastellen = Dezimaltrenner, sonst Tausendertrenner */
        if (cleaned.length - lastComma - 1 === 2) {
          cleaned = cleaned.replace(/,/g, '.');
        } else {
          cleaned = cleaned.replace(/,/g, '');
        }
      }
      var parsed = parseFloat(cleaned);
      return isNaN(parsed) ? null : Math.round(parsed * 100);
    }

    /* ══════════════════════════════════════════════════
     * STATE MANAGEMENT
     * ══════════════════════════════════════════════════ */
    function setState(name) {
      dom.inactive.hidden = (name !== 'inactive');
      dom.active.hidden   = (name !== 'active');
      dom.loading.hidden  = (name !== 'loading');
      dom.error.hidden    = (name !== 'error');
    }

    function reveal() {
      activator.classList.remove('discount-code-activator--loading');
      activator.classList.add('discount-code-activator--visible');
    }

    function showBadge(code, cart) {
      setState('active');
      if (dom.badgeText) {
        dom.badgeText.innerHTML = BADGE_TEMPLATE.replace('[code]', '<strong>' + (code || ORIGINAL_CODE) + '</strong>');
      }
      storageSafe('set', STORAGE_KEY, 'true');
      reveal();
      if (cart) {
        updatePriceDisplay(cart);
        lastCartForDrawer = cart;
      }
      if (!priceState.updated) applyStoredPriceDisplay();
      stopPolling();
      document.dispatchEvent(new CustomEvent('discount:activated', { detail: { code: ORIGINAL_CODE } }));
      log('Badge shown');
    }

    function showInactive() {
      setState('inactive');
      if (dom.applyBtn) dom.applyBtn.disabled = false;
      storageSafe('remove', STORAGE_KEY);
      resetPriceDisplay();
      lastCartForDrawer = null;
      reveal();
      document.dispatchEvent(new CustomEvent('discount:deactivated', { detail: { code: ORIGINAL_CODE } }));
      log('Inactive shown');
    }

    function stopPolling() {
      if (pollingInterval) { clearInterval(pollingInterval); pollingInterval = null; }
    }

    /* ══════════════════════════════════════════════════
     * DISCOUNT DETECTION IN CART
     * ══════════════════════════════════════════════════ */
    function isCodeActiveInCart(cart, code) {
      var upper = code.toUpperCase();
      var cd = cart.cart_level_discount_applications || [];
      for (var i = 0; i < cd.length; i++) {
        if (cd[i].title && cd[i].title.toUpperCase() === upper) return true;
      }
      var items = cart.items || [];
      for (var j = 0; j < items.length; j++) {
        var d = items[j].discounts || [];
        for (var k = 0; k < d.length; k++) {
          if (d[k].title && d[k].title.toUpperCase() === upper) return true;
        }
        var a = items[j].line_level_discount_allocations || [];
        for (var l = 0; l < a.length; l++) {
          var app = a[l].discount_application;
          if (app && app.title && app.title.toUpperCase() === upper) return true;
        }
      }
      return false;
    }

    function getItemDiscountAmount(item) {
      var total = 0;
      (item.discounts || []).forEach(function(d) {
        if (d.title && d.title.toUpperCase() === DISCOUNT_CODE) total += d.amount;
      });
      if (total === 0 && Array.isArray(item.line_level_discount_allocations)) {
        item.line_level_discount_allocations.forEach(function(a) {
          if (a.discount_application && a.discount_application.title &&
              a.discount_application.title.toUpperCase() === DISCOUNT_CODE) {
            total += a.amount;
          }
        });
      }
      return total;
    }

    /* ══════════════════════════════════════════════════
     * PRODUCT PAGE PRICE UPDATE (CLIENT-SIDE)
     * ══════════════════════════════════════════════════ */
    function getProductContainer() {
      return activator.closest('.product-info') || activator.closest('.product') || document.querySelector('.product-info');
    }

    function getVariantId() {
      var c = getProductContainer();
      if (!c) return null;
      var input = c.querySelector('form[id^="product-form-"] input[name="id"]')
        || document.querySelector('form[id^="product-form-"] input[name="id"]');
      return input ? parseInt(input.value, 10) : null;
    }

    function computeDiscountedPrice(cart) {
      var oc = null, dc = null;

      var vid = getVariantId();
      if (vid && Array.isArray(cart.items)) {
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id !== vid) continue;
          oc = cart.items[i].original_price;
          var amt = getItemDiscountAmount(cart.items[i]);
          if (amt > 0) dc = oc - Math.round(amt / cart.items[i].quantity);
          break;
        }
      }

      if (dc === null) {
        var discApps = cart.cart_level_discount_applications || [];
        var discApp = null;
        for (var j = 0; j < discApps.length; j++) {
          if (discApps[j].title && discApps[j].title.toUpperCase() === DISCOUNT_CODE) { discApp = discApps[j]; break; }
        }
        if (discApp) {
          if (priceState.originalPriceCents !== null) {
            oc = priceState.originalPriceCents;
          } else {
            var container = getProductContainer();
            var sp = container && container.querySelector('price-list sale-price');
            if (sp) {
              var txt = sp.textContent;
              var sr = sp.querySelector('.sr-only');
              if (sr) txt = txt.replace(sr.textContent, '');
              oc = parsePriceToCents(txt);
            }
          }

          if (oc !== null) {
            if (discApp.value_type === 'percentage') {
              dc = Math.round(oc * (1 - parseFloat(discApp.value) / 100));
            } else if (discApp.value_type === 'fixed_amount') {
              dc = Math.max(0, oc - Math.round(parseFloat(discApp.value) * 100));
            }
          }
        }
      }

      if (dc === null || oc === null || dc >= oc) return null;
      return { original: oc, discounted: dc };
    }

    function updatePriceDisplay(cart) {
      if (priceState.updated || priceState.updating) return;
      if (!cart) return;

      priceState.updating = true;

      var container = getProductContainer();
      var pl = container && container.querySelector('price-list');
      var sp = pl && pl.querySelector('sale-price');
      if (!sp) { priceState.updating = false; return; }

      var cp = pl.querySelector('compare-at-price');
      var hasCP = cp && !cp.hidden;

      if (priceState.originalSaleHTML === null) {
        priceState.originalSaleHTML = sp.innerHTML;
        priceState.originalSaleClass = sp.className;
        if (cp) { priceState.originalCompareHTML = cp.innerHTML; priceState.originalCompareHidden = cp.hidden; }

        var txt = sp.textContent;
        var sr = sp.querySelector('.sr-only');
        if (sr) txt = txt.replace(sr.textContent, '');
        priceState.originalPriceCents = parsePriceToCents(txt);
        log('Original price saved:', priceState.originalPriceCents, 'cents');
      }

      var prices = computeDiscountedPrice(cart);
      if (!prices) { priceState.updating = false; return; }

      var srEl = sp.querySelector('.sr-only');
      sp.innerHTML = (srEl ? srEl.outerHTML : '<span class="sr-only">Angebot</span>') + fmtMoney(prices.discounted);
      if (sp.className.indexOf('text-on-sale') === -1) sp.className = sp.className.replace(/\btext-lg\b/, 'text-lg text-on-sale');

      if (cp && !hasCP) {
        var csr = cp.querySelector('.sr-only');
        cp.innerHTML = (csr ? csr.outerHTML : '<span class="sr-only">Regulärer Preis</span>') + fmtMoney(prices.original);
        cp.hidden = false;
      }

      priceState.updated = true;
      priceState.updating = false;
      var vid = getVariantId();
      if (vid) storageSafe('set', STORAGE_KEY + '_pc', JSON.stringify({d: prices.discounted, o: prices.original, v: vid}));
      log('Product price updated:', fmtMoney(prices.original), '→', fmtMoney(prices.discounted));
    }

    function applyStoredPriceDisplay() {
      if (priceState.updated || priceState.updating) return;
      var stored = storageSafe('get', STORAGE_KEY + '_pc');
      if (!stored) return;
      try {
        var pd = JSON.parse(stored);
        if (!pd || typeof pd.d !== 'number' || typeof pd.o !== 'number') return;
        if (pd.v !== getVariantId()) return;
        if (pd.d >= pd.o) return;
        var container = getProductContainer();
        var pl = container && container.querySelector('price-list');
        var sp = pl && pl.querySelector('sale-price');
        if (!sp) return;
        var cp = pl.querySelector('compare-at-price');
        priceState.updating = true;
        if (priceState.originalSaleHTML === null) {
          priceState.originalSaleHTML = sp.innerHTML;
          priceState.originalSaleClass = sp.className;
          if (cp) { priceState.originalCompareHTML = cp.innerHTML; priceState.originalCompareHidden = cp.hidden; }
          var txt = sp.textContent;
          var sr = sp.querySelector('.sr-only');
          if (sr) txt = txt.replace(sr.textContent, '');
          priceState.originalPriceCents = parsePriceToCents(txt);
        }
        var srEl = sp.querySelector('.sr-only');
        sp.innerHTML = (srEl ? srEl.outerHTML : '<span class="sr-only">Angebot</span>') + fmtMoney(pd.d);
        if (sp.className.indexOf('text-on-sale') === -1) sp.className = sp.className.replace(/\btext-lg\b/, 'text-lg text-on-sale');
        if (cp && cp.hidden) {
          var csr = cp.querySelector('.sr-only');
          cp.innerHTML = (csr ? csr.outerHTML : '<span class="sr-only">Regulärer Preis</span>') + fmtMoney(pd.o);
          cp.hidden = false;
        }
        priceState.updated = true;
        priceState.updating = false;
        log('Price restored from cache:', fmtMoney(pd.o), '→', fmtMoney(pd.d));
      } catch(e) { priceState.updating = false; }
    }

    function resetPriceDisplay() {
      if (!priceState.updated || priceState.originalSaleHTML === null) return;
      storageSafe('remove', STORAGE_KEY + '_pc');
      var container = getProductContainer();
      var pl = container && container.querySelector('price-list');
      if (!pl) return;
      var sp = pl.querySelector('sale-price');
      var cp = pl.querySelector('compare-at-price');
      if (sp) { sp.innerHTML = priceState.originalSaleHTML; sp.className = priceState.originalSaleClass; }
      if (cp && priceState.originalCompareHidden) { cp.innerHTML = priceState.originalCompareHTML || ''; cp.hidden = true; }
      priceState.updated = false;
      priceState.originalSaleHTML = null;
      priceState.originalSaleClass = null;
      priceState.originalCompareHTML = null;
      priceState.originalCompareHidden = true;
      priceState.originalPriceCents = null;
    }

    /* ══════════════════════════════════════════════════
     * CART DRAWER LINE-ITEM PRICE UPDATE
     * ══════════════════════════════════════════════════ */
    function updateCartDrawerPrices(cart) {
      if (!cart || !cart.items || !cart.items.length) return;
      var cartDrawer = document.getElementById('cart-drawer');
      if (!cartDrawer) return;
      var lineItems = cartDrawer.querySelectorAll('line-item');
      if (!lineItems.length) return;

      var updated = 0;

      lineItems.forEach(function(lineEl) {
        var qtyInput = lineEl.querySelector('[data-line-key]');
        if (!qtyInput) return;
        var lineKey = qtyInput.getAttribute('data-line-key');

        var cartItem = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === lineKey) { cartItem = cart.items[i]; break; }
        }
        if (!cartItem) {
          var vid = parseInt(lineKey.split(':')[0], 10);
          for (var j = 0; j < cart.items.length; j++) {
            if (cart.items[j].variant_id === vid) { cartItem = cart.items[j]; break; }
          }
        }
        if (!cartItem) return;

        var discountTotal = getItemDiscountAmount(cartItem);
        if (discountTotal <= 0) return;

        var originalPrice = cartItem.original_price;
        var discountedPrice = originalPrice - Math.round(discountTotal / cartItem.quantity);
        if (discountedPrice >= originalPrice || discountedPrice < 0) return;

        lineEl.querySelectorAll('price-list').forEach(function(pl) {
          var salePrice = pl.querySelector('sale-price');
          if (!salePrice) return;
          var compareAt = pl.querySelector('compare-at-price');
          var hasExistingCompare = compareAt && !compareAt.hidden;

          var srEl = salePrice.querySelector('.sr-only');
          salePrice.innerHTML = (srEl ? srEl.outerHTML : '<span class="sr-only">Angebot</span>') + fmtMoney(discountedPrice);
          salePrice.classList.remove('text-subdued');
          salePrice.classList.add('text-on-sale');

          if (!hasExistingCompare) {
            if (!compareAt) {
              compareAt = document.createElement('compare-at-price');
              compareAt.className = 'text-subdued line-through';
              pl.appendChild(compareAt);
            }
            compareAt.innerHTML = '<span class="sr-only">Regulärer Preis</span>' + fmtMoney(originalPrice);
            compareAt.hidden = false;
          }
        });

        updated++;
      });

      if (updated > 0) log('Cart drawer: ' + updated + ' line-item prices updated');
    }

    /* ══════════════════════════════════════════════════
     * CART SECTION DETECTION
     * ══════════════════════════════════════════════════ */
    function detectCartSectionIds() {
      var ids = [];
      var known = [
        'cart-drawer', 'cart-items', 'main-cart-items',
        'cart-footer', 'main-cart-footer', 'cart-icon-bubble',
        'cart-notification', 'cart-notification-button',
        'mini-cart', 'ajax-cart', 'sidebar-cart'
      ];
      known.forEach(function(id) {
        if (document.getElementById('shopify-section-' + id)) ids.push(id);
      });
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function(el) {
        var id = el.id.replace('shopify-section-', '');
        if (ids.indexOf(id) === -1 && /cart|mini.?cart|drawer.*cart|cart.*drawer|warenkorb/i.test(id + ' ' + (el.className || ''))) {
          ids.push(id);
        }
      });
      return ids.slice(0, 5);
    }

    /* ══════════════════════════════════════════════════
     * THEME-COMPATIBLE CART EVENTS
     * ══════════════════════════════════════════════════ */
    function fireCartEvents(cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: cart }
      }));

      lastCartForDrawer = cart;

      /* Mehrfache Updates mit gestaffelten Delays um Section Rendering zu überstehen */
      setTimeout(function() { updateCartDrawerPrices(cart); }, 300);
      setTimeout(function() { updateCartDrawerPrices(cart); }, 800);
      setTimeout(function() { updateCartDrawerPrices(cart); }, 1500);

      document.dispatchEvent(new CustomEvent('discount:applied', {
        detail: { code: DISCOUNT_CODE, cart: cart }
      }));

      updateCartCount(cart);
    }

    function updateCartCount(cart) {
      var count = cart.item_count;
      if (typeof count === 'undefined') return;
      [
        '.cart-count-bubble span[aria-hidden]', '.cart-count-bubble span',
        '.cart-count', '[data-cart-count]', '.js-cart-count',
        '.header__cart-count', '#cart-icon-bubble .cart-count', '.cart-count-badge'
      ].forEach(function(sel) {
        document.querySelectorAll(sel).forEach(function(el) {
          if (el.textContent.trim() !== String(count)) el.textContent = count;
        });
      });
    }

    /* ══════════════════════════════════════════════════
     * DISCOUNT APPLICATION
     * ══════════════════════════════════════════════════ */
    function applyDiscount(code) {
      log('Applying:', code);
      setState('loading');
      reveal();
      if (dom.applyBtn) dom.applyBtn.disabled = true;

      var sections = detectCartSectionIds();
      var body = { discount: code };
      if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }

      return fetchJSON(ROOT_URL + 'cart/update.js', { method: 'POST', body: body })
        .then(function(cart) {
          fireCartEvents(cart);
          var empty = !cart.items || !cart.items.length;

          if (isCodeActiveInCart(cart, code)) {
            showBadge(code, cart);
            return true;
          }

          if (empty) {
            handleNotVisible(code);
            return true;
          }

          return retryCheck(code);
        })
        .catch(function(err) { log('Error:', err); return applyDiscountLegacy(code); });
    }

    function retryCheck(code) {
      return new Promise(function(resolve) {
        setTimeout(function() {
          var sections = detectCartSectionIds();
          fetchCartJSON(sections).then(function(cart) {
            fireCartEvents(cart);
            var empty = !cart.items || !cart.items.length;
            if (isCodeActiveInCart(cart, code)) {
              showBadge(code, cart);
              resolve(true);
            }
            else if (empty) { handleNotVisible(code); resolve(true); }
            else { handleNotVisible(code); resolve(false); }
          }).catch(function() { handleNotVisible(code); resolve(false); });
        }, 1500);
      });
    }

    function applyDiscountLegacy(code) {
      return fetch(ROOT_URL + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function() {
          var sections = detectCartSectionIds();
          var body = {};
          if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
          return fetchJSON(ROOT_URL + 'cart/update.js', { method: 'POST', body: body });
        })
        .then(function(cart) {
          fireCartEvents(cart);
          var empty = !cart.items || !cart.items.length;
          if (isCodeActiveInCart(cart, code)) {
            showBadge(code, cart);
            return true;
          }
          if (empty) { handleNotVisible(code); return true; }
          handleNotVisible(code); return false;
        })
        .catch(function() { setState('error'); setTimeout(showInactive, 5000); return false; });
    }

    function handleNotVisible(code) {
      var d = new Date();
      d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000);
      document.cookie = 'discount_code=' + code + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';

      fetchCartJSON().then(function(cart) {
        showBadge(code, cart);
      }).catch(function() {
        showBadge(code, null);
      });
    }

    /* ══════════════════════════════════════════════════
     * STATUS CHECKS
     * ══════════════════════════════════════════════════ */
    function isCodeActiveInNotice() {
      try {
        var ref = (localStorage.getItem('discount_code_referrer') || '').toUpperCase().trim();
        return ref === DISCOUNT_CODE;
      } catch(e) { return false; }
    }

    function initialCheck() {
      if (initialCheckDone) return;
      initialCheckDone = true;

      fetchCartJSON().then(function(cart) {
        var empty = !cart.items || !cart.items.length;
        var active = isCodeActiveInCart(cart, DISCOUNT_CODE);
        var localActive = storageSafe('get', STORAGE_KEY) === 'true';
        var noticeActive = isCodeActiveInNotice();
        if (active || noticeActive || (empty && localActive)) {
          showBadge(null, cart);
        } else {
          showInactive();
        }
      }).catch(showInactive);
    }

    function periodicCheck() {
      fetchCartJSON().then(function(cart) {
        var empty = !cart.items || !cart.items.length;
        var active = isCodeActiveInCart(cart, DISCOUNT_CODE);
        var shouldShow = active || (empty && storageSafe('get', STORAGE_KEY) === 'true');

        if (shouldShow) {
          if (!dom.active.hidden) {
            if (!empty) {
              lastCartForDrawer = cart;
              updateCartDrawerPrices(cart);
            }
            return;
          }
          showBadge(null, cart);
        } else {
          if (!dom.inactive.hidden) return;
          showInactive();
        }
      }).catch(function() {});
    }

    /* ══════════════════════════════════════════════════
     * CART DRAWER OPEN HANDLER + MUTATION OBSERVER
     * ══════════════════════════════════════════════════ */
    function onCartDrawerOpen() {
      if (lastCartForDrawer && !dom.active.hidden) {
        setTimeout(function() { updateCartDrawerPrices(lastCartForDrawer); }, 300);
      }
    }

    var cartDrawerEl = document.getElementById('cart-drawer');
    if (cartDrawerEl) {
      cartDrawerEl.addEventListener('dialog:after-show', onCartDrawerOpen);

      /* MutationObserver: Erkennt Section Rendering und updated Preise erneut */
      var observer = new MutationObserver(function(mutations) {
        var hasLineItemChanges = mutations.some(function(m) {
          return m.addedNodes.length > 0 || m.removedNodes.length > 0;
        });

        if (hasLineItemChanges && lastCartForDrawer && !dom.active.hidden) {
          log('Cart Drawer DOM changed - re-applying prices');
          setTimeout(function() { updateCartDrawerPrices(lastCartForDrawer); }, 100);
        }
      });

      observer.observe(cartDrawerEl, {
        childList: true,
        subtree: true
      });
    }

    /* ══════════════════════════════════════════════════
     * INITIALIZATION
     * ══════════════════════════════════════════════════ */
    if (dom.applyBtn) {
      dom.applyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        applyDiscount(ORIGINAL_CODE);
      });
    }

    var urlParams = new URLSearchParams(window.location.search);
    var urlDiscount = urlParams.get('discount');
    var isAutoApply = urlDiscount && urlDiscount.toUpperCase().trim() === DISCOUNT_CODE;

    if (isAutoApply) {
      applyDiscount(urlDiscount.trim());
      if (window.history && window.history.replaceState) {
        var cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('discount');
        window.history.replaceState({}, '', cleanUrl.toString());
      }
    } else {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialCheck, { once: true });
      } else {
        initialCheck();
      }
    }

    pollingInterval = setInterval(periodicCheck, CHECK_INTERVAL);

    /* Event Listeners für Cart-Änderungen */
    document.addEventListener('variant:add', periodicCheck);
    document.addEventListener('line-item:change', periodicCheck);

    /* Zusätzliche Events für Cart Drawer Updates nach Section Rendering */
    document.addEventListener('cart:updated', function() {
      if (lastCartForDrawer && !dom.active.hidden) {
        setTimeout(function() { updateCartDrawerPrices(lastCartForDrawer); }, 200);
      }
    });

    document.documentElement.addEventListener('cart:change', function(e) {
      if (e.detail && e.detail.cart && !dom.active.hidden) {
        lastCartForDrawer = e.detail.cart;
        setTimeout(function() { updateCartDrawerPrices(e.detail.cart); }, 500);
      }
    });

    document.addEventListener('turbo:before-render', stopPolling);
  }
})();